import React, { useContext } from "react";
import { ApplicationContext } from "@context/ApplicationContext";
import FormWrapper from "@components/Wrappers/FormWrapper";
import VersionedLayout from "@components/Wrappers/VersionedLayout";

const UnsuccessfulSignInPage = () => {
    const { whiteLabel } = useContext(ApplicationContext);

    return (
        <VersionedLayout minimal>
            <FormWrapper pageTitle={`${whiteLabel?.no_public_access_title}`}>
                <p className="paragraph">
                    {whiteLabel?.no_public_access_body}
                    {whiteLabel?.no_public_access_link_url &&
                        whiteLabel?.no_public_access_link_value && (
                            <a
                                href={whiteLabel?.no_public_access_link_url}
                                className="link"
                            >
                                {whiteLabel?.no_public_access_link_value}
                            </a>
                        )}
                </p>
                <a className="button button__primary" href={`${whiteLabel?.no_public_access_link_url}`}>
                    {whiteLabel?.no_public_access_link_value}
                </a>
            </FormWrapper>
        </VersionedLayout>
    );
};

export default UnsuccessfulSignInPage;
